<ion-content
  class="modal-outher-container"
  [ngClass]="{ 'report-task-modal__border--gray': editContractorModalOpened }"
>
  <ion-grid
    class="modal-inner-container modal-inner-container--scroll custom-scrollbar"
  >
    <div
      class="report-task-modal__cover"
      *ngIf="editContractorModalOpened"
    ></div>
    <ion-row>
      <ion-col>
        <app-modal-header
          header="{{ 'REPORT_TASK.EDIT_TASK' | translate }}"
          (close)="close()"
        >
        </app-modal-header>
      </ion-col>
      <ion-col size="12">
        <app-report-task-detail
          [task] = 'task'
          (editContractorEvent)="onEditContactorEvent($event)"
          [reportTaskId] = "task.id"
          [isModalOpen] = "true"
        >
        </app-report-task-detail>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<!-- <div class="spin" *ngIf="showLoader">
  <app-loading-sti></app-loading-sti>
</div> -->
